module.exports = __webpack_public_path__ + "static/img/miantiao.0fbeda95.png";